import { set } from '@/utils/vuex'

export default {
  SET_USER: set('user'),
  SET_MY_TEACHER_USER: set('myTeacherUser')
}
